import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { FlatpickrOptions } from 'ng2-flatpickr';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.css']
})
export class DateTimeComponent implements OnInit, ControlValueAccessor {

  value: string;

  public config: FlatpickrOptions = {
    altFormat: 'd-m-Y H:i',
    altInputClass: 'custom-input',
    allowInput: true,
    altInput: true,
    enableTime: true,
    time_24hr: true,
    minuteIncrement: 5
  };

  @Input() name: string;
  @Input() error: string;
  @Input() label: string;
  @Input() showLabel = true;
  @Input() date: number;

  constructor(@Self() @Optional() private control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showSuccess(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return !this.control.invalid ? (dirty || touched) : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return this.invalid ? (dirty || touched) : false;
  }

  onChange: (value: string[]) => void = () => {
  }

  onTouched = () => {
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.value = value;
  }
}
